module.exports = __webpack_public_path__ + "static/media/eyelet01.aa1f547f.webp";